import type { Components } from '@mildang/mui';
import { menuItemClasses } from '@mildang/mui';
import type { Theme } from '@mildang/mui';

const createMenu = ({ palette, typography }: Theme): Components => ({
  MuiMenu: {
    styleOverrides: {
      root: {
        '.MuiPaper-root': {
          minWidth: 140,
          borderRadius: '8px',
          ['--outer-radius']: '8px',
        },
        '& .MuiMenuItem-root': {
          ...typography.body4,
        },
        '& .MuiList-padding': {
          paddingTop: 4,
          paddingBottom: 4,
        },
        '& .MuiMenuItem-root:hover': {
          backgroundColor: palette.primary.lightHover,
        },
        [`& .${menuItemClasses.root}.${menuItemClasses.selected}`]: {
          backgroundColor: palette.secondary.lightActive,
          color: palette.secondary.dark,
        },
      },
    },
  },
});

export default createMenu;
